import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { breakpoints } from '../../../../core/application/theme/breakpoints'

export interface IDaysOfWeekSelectorProps {
    daysOfWeek: number[]
    setDaysOfWeek: (daysOfWeek: number[]) => void,
    hasError: boolean
}

const days = [
    'Day.short.sunday',
    'Day.short.monday',
    'Day.short.tuesday',
    'Day.short.wednesday',
    'Day.short.thursday',
    'Day.short.friday',
    'Day.short.saturday'
]

const DaysOfWeekSelector: React.FC<IDaysOfWeekSelectorProps> = ({
    daysOfWeek,
    setDaysOfWeek,
    hasError
}) => {
    const intl = useIntl()

    const onDayClicked = (dayIndex: number) => {
        const index = daysOfWeek.indexOf(dayIndex)
        if (index >= 0) {
            const updated = [...daysOfWeek]
            updated.splice(index, 1)
            setDaysOfWeek(updated)
        } else {
            setDaysOfWeek([...daysOfWeek, dayIndex])
        }
    }

    return (
        <DaysOfWeekSelectorContainer>
            {
                days.map((value, index) => {
                    let className = daysOfWeek.includes(index) ? 'selected' : ''
                    if (hasError) {
                        className += ' error'
                    }
                    return (
                        <Day 
                            key={index}
                            onClick={() => onDayClicked(index)}
                            className={className}
                        >
                            {intl.formatMessage({id: value})}
                        </Day>
                    )
                })
            }
        </DaysOfWeekSelectorContainer>
    )
}

const DaysOfWeekSelectorContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`

const Day = styled.button`
    border-radius: 50%;
    cursor: pointer;
    width: 38px;
    height: 38px;

    background-color: ${({ theme }) => theme.color.buttonGrey};
    color: ${({ theme }) => theme.color.black};
    border: none;

    &.selected {
        background-color: ${({ theme }) => theme.color.primary};
    }

    &.error {
        border: 1px solid ${({ theme }) => theme.color.error};
    }

    @media ${breakpoints.tablet} {
        width: 48px;
        height: 48px;
    }
`

export default DaysOfWeekSelector
